<template>
  <div class="MultipleLine-container">
    <div :ref="chartid" class="chart-div"></div>
  </div>
</template>
<script>
import { getSize } from '@/utils/utils'
export default {
  name: 'MultipleLine',
  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },
    chartid: {
      type: String,
      default: 'lineTwoChart'
    }
  },
  data () {
    return {
      lineChart: null,
      labes: [],
      vals: [],
      legends: []
    }
  },
  computed: {},
  created () {
    window.addEventListener('resize', this.chartResize)
  },
  mounted () {
    this.lineChart = this.$echarts.init(this.$refs[this.chartid], null, { renderer: 'svg' })
    this.lineChart.getZr().on('click', params => {
      if (this.labes.length) {
        const pointInPixel = [params.offsetX, params.offsetY]
        if (this.lineChart.containPixel('grid', pointInPixel)) {
          const pointInGrid = this.lineChart.convertFromPixel(
            {
              seriesIndex: 0
            },
            pointInPixel
          )
          const yIndex = pointInGrid[0]
          console.log('params=====', yIndex)
          this.$emit('updateSelect', yIndex)
          // this.$emit('change', yIndex)
          // if (this.charoption.click.canclick) {
          //   this.isStart = false
          //   this.$nextTick(() => {
          //     this.setOptions(this.labels, this.vals)
          //   })
          // }
        }
      }
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.chartResize)
  },
  methods: {
    chartResize () {
      if (this.lineChart) {
        setTimeout(() => {
          this.lineChart.resize()
          this.setOptions(this.labes, this.vals, this.legends)
        }, 10)
      }
    },
    setOptions (labes, vals, legends) {
      this.labes = labes
      this.vals = vals
      this.legends = legends
      var series = []
      var objZoom = { type: 'inside', start: 0, end: this.labes.length }
      var obj1 = { start: 0, end: this.labes.length }
      var dataZoom = []
      dataZoom.push(objZoom)
      this.vals.map((item, index) => {
        var obj = { name: this.legends[index], yAxisIndex: 0, data: item, symbolSize: 5, symbol: 'none', type: 'line' }
        series.push(obj)
        dataZoom.push(obj1)
      })
      const option = {
        title: { text: '', left: '45%' },
        // color: ['#5a7ff1', '#42bf7c'],
        grid: {
          left: getSize(20),
          right: getSize(20),
          top: getSize(50),
          bottom: getSize(40),
          containLabel: true
        },
        tooltip: {
          // backgroundColor: '#3a3b3c',
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            var x = 0
            var y = 0
            var pointX = point[0]
            var pointY = point[1]
            var boxWidth = size.contentSize[0]
            var boxHeight = size.contentSize[1]
            if (boxWidth > pointX) {
              x = 5
            } else {
              x = pointX - boxWidth
            }
            if (boxHeight > pointY) {
              y = 5
            } else {
              y = pointY - boxHeight
            }
            return [x, y]
          }
        },
        legend: {
          data: this.legend,
          top: getSize(30),
          orient: 'horizontal',
          type: 'scroll'
        },
        dataZoom: dataZoom,
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisTick: {
            show: false
          },
          data: this.labes
        },
        yAxis: [{ type: 'value' }, { type: 'value' }],
        series: series
      }
      this.lineChart.setOption(option, true)
    }
  }
}
</script>
<style scoped lang="scss">
.MultipleLine-container {
  width: 100%;
  height: 100%;
  position: relative;

  .chart-div {
    width: 100%;
    height: 100%;
  }
}
</style>
